<template>
	<div class="absolute z-50 flex items-center justify-center w-full h-full">
		<span class="text-2xl text-white sm:text-3xl 2xl:text-4xl animate-float font-rounded text-shadow">Loading...</span>
	</div>
</template>

<script>
export default {
	name: 'Loading',
}
</script>
